const BASE = process.env.REACT_APP_API_URL;

export const mediaUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  return `${BASE}${path}`;
};

const TOKEN_KEY = "simashi_token";
const USER_KEY = "simashi_user";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem(USER_KEY));
  } catch {
    return null;
  }
};
export const storeAuth = (token, user) => {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(user));
};
export const clearAuth = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
};

export async function api(path, { method = "GET", body, auth = false } = {}) {
  const headers = {};
  if (body !== undefined) headers["Content-Type"] = "application/json";
  if (auth) {
    const token = getToken();
    if (token) headers["Authorization"] = `Bearer ${token}`;
  }
  let url = `${BASE}/api${path}`;
  if (method === "GET") {
    const lang = localStorage.getItem("simashi_lang");
    if (lang && lang !== "en") url += `${path.includes("?") ? "&" : "?"}lang=${lang}`;
  }
  const res = await fetch(url, {
    method,
    headers,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  let data = null;
  try {
    data = await res.json();
  } catch {
    data = null;
  }
  if (!res.ok) {
    let msg = `Request failed (${res.status})`;
    if (data && typeof data.detail === "string") msg = data.detail;
    else if (data && Array.isArray(data.detail) && data.detail[0]?.msg) msg = data.detail[0].msg;
    const err = new Error(msg);
    err.status = res.status;
    throw err;
  }
  return data;
}

export const fmtPrice = (n) =>
  n === null || n === undefined ? "" : `$${Number(n).toLocaleString(undefined, { maximumFractionDigits: 2 })}`;

export const priceLabel = (p) => {
  if (p.price_min == null && p.price_max == null) return "Ask for price";
  if (p.price_min != null && p.price_max != null && p.price_max !== p.price_min)
    return `${fmtPrice(p.price_min)} – ${fmtPrice(p.price_max)}`;
  return fmtPrice(p.price_min ?? p.price_max);
};
